import { render } from "./PrefectDashboard.vue?vue&type=template&id=635075c8&scoped=true"
import script from "./PrefectDashboard.vue?vue&type=script&lang=js"
export * from "./PrefectDashboard.vue?vue&type=script&lang=js"

import "./PrefectDashboard.vue?vue&type=style&index=0&id=635075c8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-635075c8"]])

export default __exports__